//* global window */
import { h } from './element';
import { cssPrefix } from '../config';

export default class BackgroundImage {
  constructor(formulas, viewFn, rowHeight,bgUrl) {
    this.viewFn = viewFn;
    this.rowHeight = rowHeight;
    this.formulas = formulas;

    this.el = h('div', `${cssPrefix}-background-image`).hide();

    if (bgUrl) {
      this.el.el.style.opacity = "0.5";
      this.el.el.style.height = "100%";
      this.el.el.style.backgroundImage = 'url('+imgData.url+')';
      this.el.show();
    }

    this.areaOffset = null;
    this.freeze = { w: 0, h: 0 };
    this.change = () => {};
  }

  setFreezeLengths(width, height) {
    console.log('setFreezeLengths width:', width)
    this.freeze.w = width;
    this.freeze.h = height;
  }

  clear() {
    this.el.hide();
  }

  setOffset(offset, suggestPosition = 'top',distance) {
    const {
      textEl, areaEl, suggest, freeze, el,
    } = this;
    if (offset) {
      this.areaOffset = offset;
      const {
        left, top, width, height, l, t,
      } = offset;
      console.log('width:', width, ',height:', height, ', offset:', offset);
      console.log('left:', left, ',top:', top, ', freeze:', freeze);
      const elOffset = { left: 0, top: 0 };
      // top left
      if (freeze.w > l && freeze.h > t) {
        //
      } else if (freeze.w < l && freeze.h < t) {
        elOffset.left = freeze.w;
        elOffset.top = freeze.h;
      } else if (freeze.w > l) {
        elOffset.top = freeze.h;
      } else if (freeze.h > t) {
        elOffset.left = freeze.w;
      }
      el.offset(elOffset);
      el.el.style.top = -distance+'px';
    }
  }

  show(){
    this.el.show();
  }
  hide(){
    this.el.hide();
  }
}
